// Home / questionnaire page (matches /:slug and /:slug/unsubscribe is separate).
import { PageFrame } from "../../src/app";
import { Component as HomePage } from "../../src/pages/Home";

import "../../src/theme/tailwind.css";

export default function Page() {
  return (
    <PageFrame>
      <HomePage />
    </PageFrame>
  );
}
